import { render, staticRenderFns } from "./CookiesConsent.vue?vue&type=template&id=1f36f97c&"
import script from "./CookiesConsent.vue?vue&type=script&lang=js&"
export * from "./CookiesConsent.vue?vue&type=script&lang=js&"
import style0 from "./CookiesConsent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports